"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CellSummaryApiImpl = void 0;
const tslib_1 = require("tslib");
const ApiBase_1 = require("./ApiBase");
const ModuleConstants = tslib_1.__importStar(require("../../Utilities/Constants/ModuleConstants"));
const SystemRedux = tslib_1.__importStar(require("../../Redux/ActionsReducers/SystemRedux"));
const Enums_1 = require("../../PredefinedConfig/Common/Enums");
const weightedAverage_1 = require("../../agGrid/weightedAverage");
class CellSummaryApiImpl extends ApiBase_1.ApiBase {
    openCellSummaryPopupSettingsPanel() {
        this.showModulePopup(ModuleConstants.CellSummaryModuleId);
    }
    getCurrentCellSummaryOperation() {
        return this.getAdaptableState().System.CellSummaryOperation;
    }
    getCellSummaryOperationDefinitions() {
        var _a;
        let cellSummaryOperations = (_a = this.getCellSummaryOptions().cellSummaryOperations) !== null && _a !== void 0 ? _a : [];
        if (this.isWeightedAverageCellSummaryAvailable()) {
            cellSummaryOperations = [
                ...cellSummaryOperations,
                this.getWeightedAverageCellSummaryOperation(),
            ];
        }
        return cellSummaryOperations;
    }
    setCurrentCellSummaryOperation(operation) {
        this.dispatchAction(SystemRedux.SystemCellSummaryChangeOperation(operation));
    }
    getCellSummaryOperationValue(operation) {
        const cellSummary = this.getAdaptableState().Grid.CellSummary;
        if (!cellSummary) {
            return 'N/A';
        }
        switch (operation) {
            case Enums_1.SummaryOperation.Sum:
                return cellSummary.Sum;
            case Enums_1.SummaryOperation.Average:
                return cellSummary.Average;
            case Enums_1.SummaryOperation.Median:
                return cellSummary.Median;
            case Enums_1.SummaryOperation.Mode:
                return cellSummary.Mode;
            case Enums_1.SummaryOperation.Max:
                return cellSummary.Max;
            case Enums_1.SummaryOperation.Min:
                return cellSummary.Min;
            case Enums_1.SummaryOperation.Distinct:
                return cellSummary.Distinct;
            case Enums_1.SummaryOperation.Count:
                return cellSummary.Count;
            case Enums_1.SummaryOperation.Std_Deviation:
                return cellSummary.Std_Deviation;
            case Enums_1.SummaryOperation.Only:
                return cellSummary.Only;
            default:
                return cellSummary[operation];
        }
    }
    getCurrentCellSummaryOperationValue() {
        const cellSummaryOperation = this.getCurrentCellSummaryOperation();
        const summaryOperation = typeof cellSummaryOperation === 'string'
            ? cellSummaryOperation
            : cellSummaryOperation.operationName;
        return this.getCellSummaryOperationValue(summaryOperation);
    }
    /**
     * Weighted average is availabe only if the current layout has at leat a Weighted Average aggregation defined.
     */
    isWeightedAverageCellSummaryAvailable() {
        const currentLayout = this.getAdaptableApi().layoutApi.getCurrentLayout();
        if (currentLayout.AggregationColumns == undefined) {
            return false;
        }
        return Object.values(currentLayout.AggregationColumns).some((aggCol) => typeof aggCol === 'object' && aggCol.type === 'weightedAverage');
    }
    getWeightedAverageCellSummaryOperation() {
        return {
            operationName: 'Weighted Avg',
            operationFunction: weightedAverage_1.cellSummaryWeightedAverage,
        };
    }
}
exports.CellSummaryApiImpl = CellSummaryApiImpl;
